import styled from "styled-components";
import React from "react";

export const SectionDivider = styled.div`
    width: 100px;
    height: 6px;
    border-radius: 10px;
    background-color: #fff;
    background: ${(props) => props.colorAlt ? 
        'linear-gradient(270deg, #F46737 0%, #945DD6 100%)' :
        'linear-gradient(270deg, #13ADC7 0%, #945DD6 100%)'};

        margin: ${(props) => props.divider ? "4rem 0" : "" };
`;

export const Container = styled.div`
    width: 90%;
    margin: 0 auto;
`;

export const Title = styled.h2`
    color: white;
    font-weight: 800;
    font-size: 65px;
    margin-bottom: 10px;
    text-align: left;
    @media ${(props) => 'screen and (max-width: 900px)'} {
        font-size: 48px;
        font-weight: 600;
    }
`;

export const ProjectContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 auto;
    gap: 4rem;
    width: 95%;
    @media ${(props) => 'screen and (max-width: 1280px)'} {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
    @media ${(props) => 'screen and (max-width: 700px)'} {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const ProjectCard = styled.div`
    background-color: rgba(17, 36, 72, 0.9);
    border-radius: 10px;
    box-shadow: 0px 4px 8px rgba(0,0,0,0.2), 0px 8px 16px rgba(0,0,0,0.1);
    padding: 1rem;
    position: relative;
`;

export const ProjectTitle = styled.p`
    font-size: 22px;
    font-weight: 700;
    text-align: left;
`;

export const CardShadow = styled.div`
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
`;